<div class="dialog-overlay" (click)="onClose()"></div>
<div class="dialog-container open">

  <div class="dialog-content">
    <!-- Section de l'image -->
    <div class="dialog-image">
      <!-- Vous pouvez ajouter une URL d'image ici -->
      <img src="assets/images/bg.png" alt="Image de connexion" />
    </div>
    <!-- Section du formulaire -->
    <div class="dialog-form">
      <!-- Ajout de l'image et du texte de titre -->
      <div class="form-header">
        <img src="assets/images/icon_athena_blue.png" alt="Logo" class="form-logo" />
        <h2 class="dialog-title">Connectez-vous a votre compte</h2>
      </div>
      <form>
        <div class="form-content">
          <div class="form-field">
            <input id="username" [(ngModel)]="username" name="username" placeholder="Entrer le nom d'utilisateur" />
          </div>
          <div class="form-field">
            <input
              id="password"
              [(ngModel)]="password"
              name="password"
              type="password"
              placeholder="Entrer le mot de passe"
            />
          </div>
          <div *ngIf="errorMessage" class="error-message">{{ errorMessage }}</div>
          <div class="button-container">
            <button type="button" (click)="onLogin()" class="btn">Se connecter</button>
          </div>
        </div>
      </form>
      <div class="form-footer">
        <a href="#" class="footer-link">Mot de passe oublié ?</a>
        <div>
          <b>Vous n'avez pas de compte ? </b>
          <a href="#" class="footer-link">S'enregistrer</a>
        </div>
      </div>
    </div>
  </div>
</div>
